import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Card from '@components/card-course'
import Grid from '@material-ui/core/Grid'

import { transformCasing } from '@utils/slugs'

const texts = {
  noResults: (searchTxt) => `No results for "${searchTxt}"`,
  results: {
    city: (searchTxt) => `Golf Courses in ${searchTxt}`,
    searchText: (searchTxt) => `Results for "${searchTxt}"`,
    zipCode: (searchTxt) => `15 miles from ${searchTxt}`,
  },
}

const cityState = (city, state) => `${transformCasing(city)}, ${state.toUpperCase()}`

const CourseSearchResults = React.memo((props) => {
  const {
    results,
    query,
  } = props

  let searchTxt = ''
  let searchParams = 'searchText'

  if (query) {
    const possibleSearch = ['city', 'searchText', 'zipCode']
    // eslint-disable-next-line prefer-destructuring
    searchParams = possibleSearch.filter((item) => Object.keys(query).includes(item))[0]
    searchTxt = searchParams === 'city' ? cityState(query.city, query.state) : query[searchParams]
  }

  const filteredResults = results ? results.filter((facility) => facility?.state) : results
  const hasResults = Array.isArray(filteredResults) && filteredResults.length > 0

  return (
    <div>
      <Box mb={[4, 4, 6]}>
        <Typography variant="h4" data-testid="search-results-headline">
          {hasResults ? texts.results[searchParams](searchTxt) : texts.noResults(searchTxt)}
        </Typography>
        {hasResults
          ? (
            <Typography variant="subtitle2" style={{ marginLeft: '1em', marginTop: '1em' }}>
            Click on a course to connect with a PGA Professional near you
            </Typography>
          ) : null}
      </Box>

      <Grid
        container
        spacing={2}
        data-testid="search-results-list"
      >
        {filteredResults && filteredResults.map((facility) => (
          <Grid item xs={12} md={6} key={facility.facility_id}>
            <Card {...facility} />
          </Grid>
        ))}
      </Grid>
    </div>
  )
})

CourseSearchResults.propTypes = {
  query: PropTypes.shape({
    searchText: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.string,
  }),
  results: PropTypes.array,
}

export default CourseSearchResults
